// extracted by mini-css-extract-plugin
export default {"tooltipRoot":"overschedule_tooltip-module___tooltipRoot___e9293cc9","tooltipHeader":"overschedule_tooltip-module___tooltipHeader___ec44f3ee"};